import idx from "idx"

import { formatDate, formatSlug } from "@jsUtils"

/**
 * transform - manipulate data for news stories
 * @param {object} news - news query
 * @returns {object}
 */

function transform(news) {
  const stories = news.map(story => {
    const rawDate = idx(story, _ => _.date)
    const rawSlug = idx(story, _ => _.slug)
    const rawCategory = idx(story, _ => _.category)
    const slug = `/${formatSlug(rawCategory)}/${rawSlug}`
    return {
      id: idx(story, _ => _.id),
      title: idx(story, _ => _.title),
      shortTitle: idx(story, _ => _.shortTitle),
      slug,
      source: story.source,
      date: formatDate(rawDate)
    }
  })
  return {
    stories
  }
}

export default { transform }
